import styled from 'styled-components'
import { cores } from '../../styles'

export const Teste = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

export const Calc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  height: 100%;
`

export const Inputs = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  input {
    width: 100%;
  }

  .resultado {
    border: 2px solid ${cores.laranja};
  }
`
